export default {
  setSession(state, payload) {
    state.session = payload;
  },
  setConsorcio(state, payload) {
    state.consorcio = payload;
  },
  setFinanciamento(state, payload) {
    state.financiamento = payload;
  },
  setTrend(state, payload) {
    state.trend = payload;
  },
  setFilter(state, payload) {
    state.filter = payload;
  },
  setLeads(state, payload) {
    state.leads = payload;
  },
  setLeadFromFirestore(state, payload) {
    state.leadff = payload;
  }
};
